import { Route, Routes } from 'react-router-dom';
import { Statistics } from './components/Statistics';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';
import { StatisticsActiveUsers } from './components/StatisticsActiveUsers';
import { StatisticsOffers } from './components/StatisticsOffers';

export function StatisticsRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.STATISTICS) && (
                <>
                    <Route path="country" element={<Statistics />} />
                    <Route path="offers" element={<StatisticsOffers />} />
                    <Route path="active-users" element={<StatisticsActiveUsers />} />
                </>
            )}
        </Routes>
    );
}
